// extracted by mini-css-extract-plugin
module.exports = {"label-wrapper":"label-m__label-wrapper__1SUox","label-wrapper-with-background":"label-m__label-wrapper-with-background__FW1Ja"};